var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.data.records.length !== 0
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.records.length === 0
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c("table", { ref: "container", staticClass: "c-table__container" }, [
        _c(
          "thead",
          { ref: "header", staticClass: "c-table__header" },
          _vm._l(_vm.levels, function (i) {
            return _c(
              "tr",
              { key: i, staticClass: "c-table__header-row" },
              [
                _vm._l(_vm.getTableColumns(i), function (column) {
                  return _c(
                    "th",
                    {
                      key: column.id,
                      staticClass: "c-table__column",
                      class: {
                        "c-table__column_with_filter": column.type,
                        "c-table__column_hidden": _vm.isDisabled(column.id),
                        "c-table__column_sorted": _vm.isSorted(column),
                      },
                      attrs: {
                        id: `c-table-column-${column.id}`,
                        colspan: _vm.getColspan(column),
                        rowspan: _vm.getRowspan(column),
                      },
                    },
                    [
                      _c("div", { staticClass: "c-table__column-wrapper" }, [
                        _c(
                          "div",
                          {
                            staticClass: "c-table__column-label",
                            class: {
                              "c-table__column-label-children":
                                !_vm.isCategory(column) && _vm.sortedColumn,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setSortedColumn(
                                  column,
                                  _vm.sortedColumn
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(column.label) + " ")]
                        ),
                      ]),
                    ]
                  )
                }),
                _vm.data.actions && i === 1
                  ? _c(
                      "th",
                      {
                        staticClass: "c-table__column c-table__column_actions",
                        attrs: { rowspan: _vm.levels },
                      },
                      [_c("div", { staticClass: "c-table__column-empty" })]
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          0
        ),
        _c(
          "tbody",
          { staticClass: "c-table__records" },
          [
            _vm._l(_vm.data.records, function (record, recordIndex) {
              return [
                [
                  _c(
                    "tr",
                    {
                      key: recordIndex,
                      staticClass: "c-table__record",
                      class: { order_warning: record.warning },
                    },
                    _vm._l(_vm.getTableColumns(_vm.levels), function (column) {
                      return _c(
                        "td",
                        {
                          key: column.id,
                          staticClass: "c-table__cell",
                          class: {
                            "c-table__cell_string": column.type === "string",
                            "c-table__cell_reference":
                              column.type === "reference",
                            "c-table__cell_number": column.type === "number",
                            "c-table__cell_date": column.type === "date",
                            "c-table__cell_hidden": _vm.isDisabled(column.id),
                            ["c-table__cell_" + column.id]: column.id,
                          },
                        },
                        [
                          column.id === "processed" ||
                          column.id === "estimated_actual_travel_time"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-table__cell-value c-table__cell-value__processed",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(record[column.id].value) + " "
                                  ),
                                  _vm.isShowNestedOrdersInRoutesTab
                                    ? _c(
                                        "svg",
                                        {
                                          directives: [
                                            {
                                              name: "b-toggle",
                                              rawName: "v-b-toggle",
                                              value: recordIndex.toString(),
                                              expression:
                                                "recordIndex.toString()",
                                            },
                                          ],
                                          staticClass:
                                            "c-table__cell-value__processed-button",
                                          attrs: {
                                            width: "22",
                                            height: "22",
                                            viewBox: "0 0 22 22",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "11",
                                              cy: "11",
                                              r: "10.5",
                                              fill: "white",
                                              stroke: "#D3D8DF",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                              fill: "#0066FF",
                                            },
                                          }),
                                          _c("path", {
                                            attrs: {
                                              d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                              fill: "#0066FF",
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "c-table__cell-value",
                                  domProps: {
                                    innerHTML: _vm._s(record[column.id].value),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(record[column.id].value) +
                                      " " +
                                      _vm._s(record.warning) +
                                      " "
                                  ),
                                ]
                              ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm.activeTab === "orders"
                    ? _c(
                        "b-collapse",
                        {
                          key: `${recordIndex}-collapse`,
                          staticClass:
                            "c-table__record c-table__record-collapse",
                          attrs: { id: recordIndex.toString(), tag: "tr" },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass: "c-table__record-collapse-cell",
                              attrs: { colspan: "4" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-table__record-collapse-header",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-table__record-collapse-header-title",
                                    },
                                    [_vm._v("Состав заказа")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-table__record-collapse-header-sum",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.numberWithSpaces(
                                              record.orderList.sum
                                            )
                                          ) +
                                          " ฿ "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "table",
                                {
                                  staticClass: "c-table__record-collapse-table",
                                },
                                [
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      record.orderList.items,
                                      function (item) {
                                        return _c(
                                          "tr",
                                          { key: item.name + recordIndex },
                                          [
                                            _c("td", [
                                              _vm._v(_vm._s(item.name)),
                                            ]),
                                            _c("td", [
                                              _vm._v(_vm._s(item.count)),
                                            ]),
                                            _c("td", [
                                              _vm._v(_vm._s(item.summ)),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "c-table__record-collapse-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-table__record-collapse-row-col",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-table__record-collapse-row-col-title",
                                        },
                                        [_vm._v("История изменений")]
                                      ),
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "c-table__record-collapse-table c-table__record-collapse-table-history-changes",
                                        },
                                        [
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              record.historyChanges,
                                              function (item, itemIndex) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    key: `${itemIndex}-table-record`,
                                                    class: {
                                                      "c-table__record-collapse-table-row-red":
                                                        item.d === 2,
                                                      "c-table__record-collapse-table-row-lightred":
                                                        item.d === 1,
                                                      "c-table__record-collapse-table-row-yellow":
                                                        item.d === 0,
                                                    },
                                                  },
                                                  [
                                                    _c("td", [
                                                      _vm._v(_vm._s(item.desc)),
                                                    ]),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "c-table__record-collapse-table-cell-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.time)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-table__record-collapse-row-col",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-table__record-collapse-row-col-operator",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-table__record-collapse-row-col-operator-title",
                                            },
                                            [_vm._v("Оператор")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-table__record-collapse-row-col-operator-name",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(record.operator) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-table__record-collapse-row-col-driver",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-table__record-collapse-row-col-driver-title",
                                            },
                                            [_vm._v("Водитель")]
                                          ),
                                          record.drivers &&
                                          record.drivers.length
                                            ? _c("c-input", {
                                                attrs: {
                                                  type: "select",
                                                  items: record.drivers,
                                                  placeholder:
                                                    "Выберите водителя",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.ChangeDriver(
                                                      record
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: record.currentDriver,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      record,
                                                      "currentDriver",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "record.currentDriver",
                                                },
                                              })
                                            : _vm._e(),
                                          !record.drivers ||
                                          !record.drivers.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__record-collapse-row-col-operator-name",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(record.courier) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-table__record-collapse-row-col-delivery",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-table__record-collapse-row-col-delivery-title",
                                            },
                                            [_vm._v("Доставка")]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-table__record-collapse-row-col-delivery-items",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__record-collapse-row-col-delivery-items-item",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 14 14",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                                          stroke: "#8E9CBB",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.delivery
                                                          .when_delivered
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__record-collapse-row-col-delivery-items-item",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "14",
                                                        height: "14",
                                                        viewBox: "0 0 14 14",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                                          stroke: "#8E9CBB",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                        },
                                                      }),
                                                      _c("circle", {
                                                        attrs: {
                                                          cx: "7",
                                                          cy: "10",
                                                          r: "1",
                                                          fill: "#8E9CBB",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.delivery
                                                          .elapsed_time
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__record-collapse-row-col-delivery-items-item",
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      attrs: {
                                                        width: "14",
                                                        height: "17",
                                                        viewBox: "0 0 14 17",
                                                        fill: "none",
                                                        xmlns:
                                                          "http://www.w3.org/2000/svg",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M13 7C13 11.6667 7 15.6667 7 15.6667C7 15.6667 1 11.6667 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z",
                                                          stroke: "#8E9CBB",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                        },
                                                      }),
                                                      _c("path", {
                                                        attrs: {
                                                          d: "M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
                                                          stroke: "#8E9CBB",
                                                          "stroke-width": "2",
                                                          "stroke-linecap":
                                                            "round",
                                                          "stroke-linejoin":
                                                            "round",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        record.delivery.point
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.activeTab === "routes"
                    ? _c(
                        "b-collapse",
                        {
                          key: `${recordIndex}-routes-collapse`,
                          staticClass:
                            "c-table__record c-table__record-collapse",
                          attrs: { id: recordIndex.toString(), tag: "tr" },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticClass:
                                "c-table__record-collapse-cell c-table__record-collapse-cell-grey",
                              attrs: { colspan: "4" },
                            },
                            [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "c-table__record-collapse-routes-order-table",
                                },
                                [
                                  _c(
                                    "thead",
                                    { staticClass: "c-table__header" },
                                    [
                                      _c(
                                        "tr",
                                        { staticClass: "c-table__header-row" },
                                        [
                                          _c(
                                            "th",
                                            { staticClass: "c-table__column" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__column-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__column-label",
                                                    },
                                                    [_vm._v("№ заказа")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "c-table__column" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__column-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__column-label",
                                                    },
                                                    [_vm._v("Старт обработки")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "c-table__column" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__column-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__column-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Окончание обработки"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "c-table__column" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__column-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__column-label",
                                                    },
                                                    [_vm._v("Сумма заказа, ฿")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "th",
                                            { staticClass: "c-table__column" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__column-wrapper",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__column-label",
                                                    },
                                                    [_vm._v("Обработал")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        record.orders,
                                        function (item, indexNested) {
                                          return [
                                            _c(
                                              "tr",
                                              {
                                                key: `${indexNested}-table-cell-value`,
                                                class: {
                                                  order_warning: item.warning,
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "c-table__cell c-table__cell__white",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.number
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "c-table__cell c-table__cell__white",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.start_time
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "c-table__cell c-table__cell__white",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.close_time
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "c-table__cell c-table__cell__white",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(item.sum) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "c-table__cell c-table__cell__white",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__cell-value c-table__cell-value__processed",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.operator
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "svg",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "b-toggle",
                                                                rawName:
                                                                  "v-b-toggle",
                                                                value:
                                                                  indexNested.toString() +
                                                                  recordIndex.toString() +
                                                                  "nested",
                                                                expression:
                                                                  "indexNested.toString() + recordIndex.toString() + 'nested'",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "c-table__cell-value__processed-button",
                                                            attrs: {
                                                              width: "22",
                                                              height: "22",
                                                              viewBox:
                                                                "0 0 22 22",
                                                              fill: "none",
                                                              xmlns:
                                                                "http://www.w3.org/2000/svg",
                                                            },
                                                          },
                                                          [
                                                            _c("circle", {
                                                              attrs: {
                                                                cx: "11",
                                                                cy: "11",
                                                                r: "10.5",
                                                                fill: "white",
                                                                stroke:
                                                                  "#D3D8DF",
                                                              },
                                                            }),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                                                fill: "#0066FF",
                                                              },
                                                            }),
                                                            _c("path", {
                                                              attrs: {
                                                                d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                                                fill: "#0066FF",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-collapse",
                                              {
                                                key: `${indexNested}-nested-collapse`,
                                                staticClass:
                                                  "c-table__record c-table__record-collapse",
                                                attrs: {
                                                  id:
                                                    indexNested.toString() +
                                                    recordIndex.toString() +
                                                    "nested",
                                                  tag: "tr",
                                                },
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "c-table__record-collapse-cell",
                                                    attrs: { colspan: "5" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__record-collapse-header",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__record-collapse-header-title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Состав заказа"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__record-collapse-header-sum",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.numberWithSpaces(
                                                                    item.sum
                                                                  )
                                                                ) +
                                                                " ฿ "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "table",
                                                      {
                                                        staticClass:
                                                          "c-table__record-collapse-table",
                                                      },
                                                      [
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            item.items,
                                                            function (product) {
                                                              return _c(
                                                                "tr",
                                                                {
                                                                  key:
                                                                    product.name +
                                                                    recordIndex +
                                                                    indexNested,
                                                                },
                                                                [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        product.name
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        product.amount
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        product.sum
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__record-collapse-row",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__record-collapse-row-col",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__record-collapse-row-col-title",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "История изменений 3"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "table",
                                                              {
                                                                staticClass:
                                                                  "c-table__record-collapse-table c-table__record-collapse-table-history-changes",
                                                              },
                                                              [
                                                                _c(
                                                                  "tbody",
                                                                  _vm._l(
                                                                    item.history,
                                                                    function (
                                                                      historyItem
                                                                    ) {
                                                                      return _c(
                                                                        "tr",
                                                                        {
                                                                          key: `${historyItem.t}-history-item`,
                                                                          class:
                                                                            {
                                                                              "c-table__record-collapse-table-row-red":
                                                                                historyItem.d ===
                                                                                2,
                                                                              "c-table__record-collapse-table-row-lightred":
                                                                                historyItem.d ===
                                                                                1,
                                                                              "c-table__record-collapse-table-row-yellow":
                                                                                historyItem.d ===
                                                                                0,
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "td",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  historyItem.n
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              staticClass:
                                                                                "c-table__record-collapse-table-cell-bold",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  historyItem.t
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__record-collapse-row-col",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__record-collapse-row-col-operator",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "c-table__record-collapse-row-col-operator-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Оператор"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "c-table__record-collapse-row-col-operator-name",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.operator
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__record-collapse-row-col-driver",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "c-table__record-collapse-row-col-driver-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Водитель"
                                                                    ),
                                                                  ]
                                                                ),
                                                                record.drivers &&
                                                                record.drivers
                                                                  .length
                                                                  ? _c(
                                                                      "c-input",
                                                                      {
                                                                        attrs: {
                                                                          type: "select",
                                                                          placeholder:
                                                                            "Выберите водителя",
                                                                          items:
                                                                            record.drivers,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            record.currentDriver,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                record,
                                                                                "currentDriver",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "record.currentDriver",
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                !record.drivers ||
                                                                !record.drivers
                                                                  .length
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "c-table__record-collapse-row-col-operator-name",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item.courier
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__record-collapse-row-col-delivery",
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "c-table__record-collapse-row-col-delivery-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Доставка"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "c-table__record-collapse-row-col-delivery-items",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "c-table__record-collapse-row-col-delivery-items-item",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                width:
                                                                                  "14",
                                                                                height:
                                                                                  "14",
                                                                                viewBox:
                                                                                  "0 0 14 14",
                                                                                fill: "none",
                                                                                xmlns:
                                                                                  "http://www.w3.org/2000/svg",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    d: "M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                                                                    stroke:
                                                                                      "#8E9CBB",
                                                                                    "stroke-width":
                                                                                      "2",
                                                                                    "stroke-linecap":
                                                                                      "round",
                                                                                    "stroke-linejoin":
                                                                                      "round",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item
                                                                                .delivery
                                                                                .time[0] +
                                                                                " " +
                                                                                item
                                                                                  .delivery
                                                                                  .time[1]
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "c-table__record-collapse-row-col-delivery-items-item",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                width:
                                                                                  "14",
                                                                                height:
                                                                                  "14",
                                                                                viewBox:
                                                                                  "0 0 14 14",
                                                                                fill: "none",
                                                                                xmlns:
                                                                                  "http://www.w3.org/2000/svg",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    d: "M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
                                                                                    stroke:
                                                                                      "#8E9CBB",
                                                                                    "stroke-width":
                                                                                      "2",
                                                                                    "stroke-linecap":
                                                                                      "round",
                                                                                    "stroke-linejoin":
                                                                                      "round",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "circle",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    cx: "7",
                                                                                    cy: "10",
                                                                                    r: "1",
                                                                                    fill: "#8E9CBB",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.getTimeDifference(
                                                                                item.start_time,
                                                                                item.close_time
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "c-table__record-collapse-row-col-delivery-items-item",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "svg",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                width:
                                                                                  "14",
                                                                                height:
                                                                                  "17",
                                                                                viewBox:
                                                                                  "0 0 14 17",
                                                                                fill: "none",
                                                                                xmlns:
                                                                                  "http://www.w3.org/2000/svg",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    d: "M13 7C13 11.6667 7 15.6667 7 15.6667C7 15.6667 1 11.6667 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z",
                                                                                    stroke:
                                                                                      "#8E9CBB",
                                                                                    "stroke-width":
                                                                                      "2",
                                                                                    "stroke-linecap":
                                                                                      "round",
                                                                                    "stroke-linejoin":
                                                                                      "round",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _c(
                                                                              "path",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    d: "M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
                                                                                    stroke:
                                                                                      "#8E9CBB",
                                                                                    "stroke-width":
                                                                                      "2",
                                                                                    "stroke-linecap":
                                                                                      "round",
                                                                                    "stroke-linejoin":
                                                                                      "round",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              item
                                                                                .delivery
                                                                                .address
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
              ]
            }),
            _vm.activeTab === "orders" && _vm.data.records.length > 0
              ? _c("tr", { staticClass: "c-table__record" }, [
                  _c(
                    "td",
                    {
                      staticClass: "c-table__record__total__cell",
                      attrs: { colspan: "2" },
                    },
                    [
                      _c("div", { staticClass: "c-table__record__total" }, [
                        _c(
                          "div",
                          { staticClass: "c-table__record__total__value" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-table__record__total__value__desc",
                              },
                              [_vm._v("Всего заказов:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-table__record__total__value__count",
                              },
                              [_vm._v(_vm._s(_vm.data.records.length))]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticClass: "c-table__record__total__cell",
                      attrs: { colspan: "2" },
                    },
                    [
                      _c("div", { staticClass: "c-table__record__total" }, [
                        _c(
                          "div",
                          { staticClass: "c-table__record__total__value" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-table__record__total__value__desc",
                              },
                              [_vm._v("Сумма заказов:")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "c-table__record__total__value__count",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      Math.round(
                                        _vm.data.records.reduce((a, b) => {
                                          return a + b.summ_order.value
                                        }, 0) * 100
                                      ) / 100
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
            _c("tr", { staticClass: "c-table__record" }, [
              _c(
                "td",
                {
                  staticClass: "c-table__record__total__cell",
                  staticStyle: { padding: "10px" },
                  attrs: { colspan: "4" },
                },
                [
                  _c("c-button", {
                    staticClass:
                      "delivery-header-buttons-left-recalculate-routes",
                    attrs: {
                      icon: "routes",
                      label: "Пересчитать маршруты",
                      size: "small",
                      responsive: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.recountDriver(_vm.data)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          2
        ),
      ]),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }